export enum ProgramFileType {
  image = 'image',
  video = 'video',
  file = 'file',
  audio = 'audio',
}
